export default {"src":"/_next/static/media/googlecloud-icon.19b25f9a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};